import React, { useState } from 'react'
import { FormattedMessage } from 'react-intl'
import qs from 'qs'
import {
  Dialog,
  Grid,
  DialogTitle,
  ButtonBase,
  DialogContent,
  Button,
  Link as MuiLink,
  Checkbox,
} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import { makeStyles, Theme } from '@material-ui/core/styles'
import messages from '@utils/messages'
import {
  useGlobalSnackbar,
  SnackbarMessages,
} from '@src/components/GlobalSnackbar/globalSnackBarContext'
import { useUpdateEmproveUserTermsConditionsMutation } from '@src/mutations/UpdateEmproveUserTermsConditions.generated'

const useStyles = makeStyles((theme: Theme) => {
  return {
    paper: {
      borderRadius: 0,
    },
    dialogHeader: {
      fontSize: theme.typography.pxToRem(28),
      fontWeight: theme.typography.fontWeightBold,
      padding: theme.spacing(8, 10, 0, 10),
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
    },
    closeIcon: {
      fontSize: theme.typography.pxToRem(30),
    },
    dialogBody: {
      padding: theme.spacing(4, 10, 8, 7),
      fontSize: theme.typography.pxToRem(14),
    },
    resendButton: {
      position: 'relative',
      float: 'right',
      marginTop: theme.spacing(15),
      fontSize: theme.typography.pxToRem(16),
      height: theme.spacing(10),
      width: theme.spacing(40),
    },
    extraBoldText: {
      fontWeight: theme.typography.fontWeightBold,
      color: theme.palette.primary.main,
    },
  }
})

const EmproveDownloadModal = ({ open, closeModal, document, productName }) => {
  const classes = useStyles()
  const [checked, setChecked] = useState(false)
  const { setSnackbar } = useGlobalSnackbar()
  const [updateEmproveUserTermsConditions] =
    useUpdateEmproveUserTermsConditionsMutation()

  const handleClick = async () => {
    try {
      await updateEmproveUserTermsConditions()
    } catch (e) {}
    const queryParams = qs.stringify({
      dossierFileName: document.fileName,
      dossierTypeCode: document.type,
      dossierRelatedProduct: productName,
      dossierRelatedProductNo: document.product,
      dossierOrigin: 'PDP',
    })
    window.location.href = `/emprove/download/${document.assetId}?${queryParams}`
    closeModal()
    setSnackbar(SnackbarMessages.DownloadWillBeginShortly)
  }

  return (
    <Dialog open={open} maxWidth="md" classes={{ paper: classes.paper }}>
      <Grid container>
        <DialogTitle disableTypography classes={{ root: classes.dialogHeader }}>
          <FormattedMessage {...messages.DOWNLOAD_EMPROVE_DOSSIER} />
          <ButtonBase onClick={() => closeModal()}>
            <CloseIcon classes={{ root: classes.closeIcon }} />
          </ButtonBase>
        </DialogTitle>
        <DialogContent classes={{ root: classes.dialogBody }}>
          <Checkbox
            checked={checked}
            onChange={() => setChecked(!checked)}
            name="termsAndConditions"
            color="primary"
          />
          <FormattedMessage
            {...messages.ACCEPT_TERMS_AND_CONDITIONS}
            values={{
              emproveProgramTermsAndConditions: (
                <MuiLink
                  color="primary"
                  className={classes.extraBoldText}
                  target="_blank"
                  href="/life-science/legal/product-licenses/terms-and-conditions-emprove-dossier-access"
                >
                  <FormattedMessage
                    {...messages.EMPROVE_PROGRAM_TERMS_AND_CONDITIONS}
                  />
                </MuiLink>
              ),
            }}
          />
          <Button
            className={classes.resendButton}
            color="primary"
            variant="contained"
            onClick={handleClick}
            disabled={!checked}
          >
            <FormattedMessage {...messages.I_AGREE} />
          </Button>
        </DialogContent>
      </Grid>
    </Dialog>
  )
}

export default EmproveDownloadModal
